import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'

import { COLLECTION_CATEGORY } from './domains/Collection'

export const BABY_KEYWORDS = ['baby', 'toddler', 'girl', 'boy']

export const PRODUCT_TYPE_DISABLE_COLLECTION_CATEGORIES = new Set([COLLECTION_CATEGORY.PICKED_FOR_YOU])

export const VALENTINE_SLUGS = [
  '/gifts/valentines',
  '/gifts/valentines/gifts-for-men',
  '/gifts/valentines/gifts-for-women',
  '/gifts/valentines/for-going-out',
  '/gifts/valentines/for-staying-in',
  '/gifts/valentines-gifts',
  '/women/jewelry',
  '/women/jewelry/earrings',
  '/women/jewelry/necklaces',
  '/women/jewelry/rings',
  '/women/jewelry/bracelets',
  '/women/jewelry/diamond-jewelry',
  '/women/jewelry/jewelry-case',
]

export const trackingMetaData = {
  context: {
    contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.SUBCOLLECTION_DISPLAY,
    contentContainerDisplayName: CUSTOM_SECTION_CONTAINER_NAMES.SUBCOLLECTION_DISPLAY,
    trackingId: 'subcollection-display',
  },
}

export const SLUG_TO_SHOW_COLOR_CAP = ['/home', '/men', '/women']

export const DYNAMIC_FEEDS = ['/collections/picked-for-you', '/collections/trending', '/collections/trending-this-week']

export const COLOR_PAGES_RENDERED_PATHS = new Set([
  '/men/shirts',
  '/women/shirts-&-blouses',
  '/home/luxe-sheets-&-bedding',
])

export const PATH_TO_NAV_SUBSECTION = [
  '/all/new-arrivals',
  '/men-leather',
  '/women/intimates-&-shapewear',
  '/home/towels',
  '/home/bamboo',
  '/women/linen',
  '/men/linen',
]

export const COLLECTION_SLUGS_WITH_NEW_SORT = [
  '/women/cashmere',
  '/women/sweaters-&-jackets',
  '/women/bags-&-leather-goods',
  '/women/pants',
  '/women/silk',
  '/home/bedding-by-fabric',
  '/women/jackets',
  '/cotton-bedding',
  '/women/shirts-&-blouses',
  '/men/cashmere',
  '/women/activewear',
  '/baby-girl/shop-all',
]
